module.exports = __webpack_public_path__ + "media/tvSplash.07c6f4ed.mp4";